import { createSlice } from "@reduxjs/toolkit";

const initialState = null

const alertMsgSlice = createSlice({
    name: "alertMsg",
    initialState,
    reducers: {
        setAlertMsgStore: (state, action) => {
            return action.payload;
        }
    },
});

export const { setAlertMsgStore } = alertMsgSlice.actions;

export default alertMsgSlice.reducer;